<template>
  <a-modal centered :visible="visible" :width="667" :footer="null" @cancel="handleClose">
    <a-steps progress-dot :current="currentStep" class="steps" labelPlacement="vertical">
      <a-step title="Completar datos" />
      <a-step title="Asignar campaña" />
    </a-steps>

    <section class="container">
      <keep-alive>
        <component
          :is="CreateClientComponents[currentStep]"
          inContactsTable
          @client-submit="handleClientSubmit"
          @assign="handleAssign"
          @go-back="handleBack"
          @cancel="handleClose"
        />
      </keep-alive>
    </section>
  </a-modal>
</template>

<script setup>
import { ref, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { createContact, updateContact, fetchContacts } from "@/app/contacts/services";

import CreateClientForm from "@/app/workspace/components/tables/Client/steps/CreateClientForm.vue";
import CampaignTable from "@/app/workspace/components/tables/Client/steps/CampaignTable.vue";
import httpManager from "@/app/shared/utils/httpManager";

const CreateClientComponents = {
  0: CreateClientForm,
  1: CampaignTable,
};

defineProps({
  visible: { type: Boolean, default: false },
});
const emit = defineEmits(["close"]);

const currentStep = ref(0);
const clientData = ref(null);

const handleClientSubmit = (client) => {
  clientData.value = client;
  currentStep.value = 1;
};

const handleAssign = async (portfolioRecord) => {
  
  let existCode = false;
  let idContact;
  if(clientData?.value?.code){
    const data = await fetchContacts({code: clientData.value.code, campaign: portfolioRecord?.portfolioId, entity: portfolioRecord?.entityId}, {});  
    console.log(data.results.length, "data.results.lenght > 0");
    if(data.results.length > 0 && data.results?.[0]?.status == 2) {
      existCode = true;    
      idContact = data.results?.[0]?.id;
      console.log(data.results,"data.results");
    }
  } 
  
  const body = {
    ...clientData.value,
    portfolio: portfolioRecord?.portfolioId,
    ...(existCode && { status: 1 }),
  };

  const { first_name, last_name, paternal_surname, maternal_surname } = clientData.value;
  const clientName = `${first_name} ${
    last_name || `${paternal_surname ?? ""} ${maternal_surname ?? ""}`
  }`;
  const selectName = portfolioRecord?.base || portfolioRecord?.portfolio;
  const selectText = portfolioRecord?.base ? "base" : "campaña";

  Modal.confirm({
    title: existCode ? 
      `El contacto “${clientData.value.code}” ya existe pero se encuentra inactivo, ¿deseas reactivarlo?` :
      `¿Estás seguro(a) de crear el contacto en la ${selectText} ”${selectName}”?`,
    content: existCode ? 
      `Si reactivas al contacto, solo se reemplazarán aquellos datos que se ingresaron ahora.` : 
      `Recuerda que se creará al contacto ${clientName} en la ${selectText} para que puedas gestionarlo.`,
    icon: createVNode(QuestionCircleOutlined),
    centered: true,
    okText: existCode ? 
      `Si, reactivar` :
      `Crear contacto`,
    cancelText: existCode ? 
      `No, cancelar` :
      `Cancelar`,
    onOk: async () => {
      try {
        if(!existCode) {
          await createContact(body);
          message.success("Se creó el contacto correctamente");
        } else {
          await updateContact(body, idContact);
          message.success("Se ha reactivado el contacto con éxito.");
        }    
        handleUpdate();
        handleClose();
      } catch (error) {
        const errorMessage = error?.getErrorMessage() || "Ocurrió un error al crear el contacto";
        message.error(errorMessage);
        console.log(error);
      }
    },
  });
};

const handleBack = () => {
  currentStep.value = 0;
};

const handleClose = () => emit("close");

const handleUpdate = () => emit("update");
</script>

<style lang="sass" scoped>
.container
  height: 100%
  padding: 0 30px

.steps
  justify-content: center
  padding: 15px 15%

:deep(.ant-steps-item)
  padding: 0 5px

:deep(.ant-steps-item-title)
  font-size: 14px
</style>
